import React from "react";

const InstagramGallery = ({ images }) => (
  <section className="px-4 py-7 md:px-8 md:py-10 lg:px-12" data-testid="instagram-gallery">
    <div className="mb-4 md:mb-6">
      <span className="font-mono text-[10px] uppercase tracking-[0.26em] text-cynos-red md:text-xs">@cynos.in</span>
      <h2 className="mt-2 font-anton text-[clamp(2rem,8vw,3rem)] uppercase leading-none md:text-5xl">Tagged In Cynos.</h2>
    </div>
    <div className="grid grid-cols-2 gap-2 md:grid-cols-6 md:gap-3">
      {images.map((src, i) => (
        <a key={src} href="https://instagram.com" target="_blank" rel="noreferrer" className="group block aspect-square overflow-hidden rounded-[8px] bg-cynos-surface">
          <img src={src} alt="" className="h-full w-full object-cover zoom-on-hover" loading="lazy" decoding="async" sizes="(max-width: 768px) 50vw, 16vw" />
        </a>
      ))}
    </div>
  </section>
);

export default InstagramGallery;
